/**
 * Houses all the Ids assigned to the specific elements of this application DOM.
 */
class ElementIds {

    static appId: string = 'app-element-id';

    static panel = {
        appBar: 'panel-appbar-id',
        main: 'panel-main-id',
    } as const;

    static partPrices = 'part-prices-id' as const;

    static partSupportChat = {
        body: 'part-support-request-chat-body-id',
        footer: 'part-support-request-chat-footer-id',
        header: 'part-support-request-chat-header-id',
        marginBottom: 'part-support-request-chat-margin-bottom-id',
        marginTop: 'part-support-request-chat-margin-top-id',
        tabs: 'part-support-request-chat-tabs-id',
    } as const;

    static chatSection = 'chat-section-id' as const;

    static dashboardTopSection = 'dashboard-top-section-id' as const;

    static printInvoiceView = {
        page: 'page',
        table: 'table',
        pageHeader: 'page-header',
        tablesDistance: 'tables-distance',
        productsTable: {
            header: 'products-table-header',
            body: 'products-table-body',
            bodyFiller: 'products-table-body-filler',
            footerContinue: 'products-table-footer-continue',
            footer: 'products-table-footer',
        },
        notesTable: {
            header: 'notes-table-header',
            body: 'notes-table-body',
            footerContinue: 'notes-table-footer-continue',
        },
    } as const;

    static printCustomerOutstandingStatement = {
        page: 'page',
        table: 'table',
        pageHeader: 'page-header',
        productsTable: {
            header: 'products-table-header',
            body: 'products-table-body',
            bodyFiller: 'products-table-body-filler',
            footer: 'products-table-footer',
            footerContinue: 'products-table-footer-continue',
        },
    }

    static printPurchaseView = {
        page: 'purchase-print-page',
        table: 'purchase-print-table',
        pageHeader: 'purchase-print-page-header',
        productsTable: {
            header: 'purchase-print-products-table-header',
            body: 'purchase-print-products-table-body',
            bodyFiller: 'purchase-print-products-table-body-filler',
            footerContinue: 'purchase-print-products-table-footer-continue',
            footer: 'purchase-print-products-table-footer',
        },
    } as const;
}

export default ElementIds;